import { Injectable } from '@angular/core';
import { Rest, RestService } from '@abp/ng.core';

@Injectable({
    providedIn: 'root'
})
export class AddressKeyService {

    addressKey: any;
    constructor(private readonly rest: RestService) { }

    getKey = () =>
        this.rest.request<any, any>({
            method: 'GET',
            url: '/api/setting-management/AddresskeySetting',
        });
}